// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"2ac52bc5","275":"75e3a73d","489":"287d3b0c"}[chunkId] + ".chunk.css";
};